import React, { ReactElement } from "react";
import { Icon } from "../components/icon";
import QrSvg from "./qr-code.svg";
import QrAddSvg from "./qr-code-add.svg";
import ZoomSvg from "./zoom.svg";
import ZoomIn from "./zoom-in.svg";
import ZoomOut from "./zoom-out.svg";
import Hamburger from "./hamburger.svg";
import TextColor from "./text-color.svg";
import Image from "./image.svg";
import AiImage from "./image-ai.svg";
import Devices from "./devices.svg";

/**
 * Function that creates an SvgIcon by wrapping the SVG with an Icon component
 * - function so we easily can create similar SVG icons in the same way
 * - by exporting them as variables, the auto import of VS code can find them easily
 * - we wrap it so the icons have the same width/height
 */
function createSvgIcon(iconName: string, svg: ReactElement) {
	function EmbeddedSvgIcon(props: React.HTMLProps<HTMLSpanElement>) {
		return (
			<Icon iconName={iconName} {...props}>
				{svg}
			</Icon>
		);
	}
	EmbeddedSvgIcon.displayName = "EmbeddedSvgIcon";

	return EmbeddedSvgIcon;
}

export const QrIcon = createSvgIcon("qr-code", <QrSvg />);
export const QrAddIcon = createSvgIcon("qr-code-add", <QrAddSvg />);
export const ZoomIcon = createSvgIcon("zoom", <ZoomSvg />);
export const ZoomInIcon = createSvgIcon("zoom-in", <ZoomIn />);
export const ZoomOutIcon = createSvgIcon("zoom-out", <ZoomOut />);
export const HamburgerIcon = createSvgIcon("hamburger", <Hamburger />);
export const DevicesIcon = createSvgIcon("devices", <Devices />);

export function TextColorIcon({
	textColor,
	style,
	...props
}: { textColor?: eXpress.HexColorString } & React.HTMLProps<HTMLSpanElement>) {
	return (
		<Icon
			iconName="text-color"
			style={
				{
					"--bar-color": textColor,
					...style,
				} as React.CSSProperties & Record<string, any>
			}
			{...props}
		>
			<TextColor />
		</Icon>
	);
}

export const ImageIcon = createSvgIcon("image", <Image />);
export const AiImageIcon = createSvgIcon("image-ai", <AiImage />);
